import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const PartnerJoinSection = () => {
  const { t } = useTranslation();

  return (
    <section id="partner" className="bg-gray-100 py-20 px-6 text-center">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-800">
          {t('partnerSection.title', 'Ayo Kolaborasi Menjadi Mitra Pilari')}
        </h2>
        <p className="text-md md:text-lg text-gray-600 mb-8">
          {t('partnerSection.subtitle', 'Kami membuka peluang bagi komunitas, organisasi, sekolah, dan bisnis untuk bekerja sama dalam mewujudkan pengelolaan sampah yang berkelanjutan.')}
        </p>
        <Link
          to="/partner-join"
          className="inline-block bg-primaryAccent text-white px-6 py-3 rounded-full font-semibold hover:bg-primaryAccent/90 transition"
        >
          {t('partnerSection.button', 'Daftar Sebagai Mitra')}
        </Link>
      </div>
    </section>
  );
};

export default PartnerJoinSection;
